import Element, { ElementType, SpecyficType } from '@/models/element';
import { IElementToSimpleSamElementsMapper } from '../elementToSimpleSapElementsMapper';
import { BodyToSimpleSapElementMapper } from './bodyToSimpleSapElementMapper';
import { FrontToSimpleSapElementMapper } from './frontToSimpleSapElementMapper';
import { NullToSimpleSapELementMapper } from '../nullToSimpleSapElementMapper';
import { DrawerToSimpleSapElementMapper } from './drawerToSimpleSapElementMapper';
import { VerticalWallToSimpleSapElementMapper } from './verticalWallToSimpleSapElementMapper';
import { HorizontalWallToSimpleSapElementMapper } from './horizontalWallToSimpleSapElementMapper';
import { ShelfToSimpleSapElementMapper } from './shelfToSimpleSapElementMapper';
import { HandleToSimpleSapElementMapper } from '../handleToSimpleSapElementMapper';
import { LegsToSimpleSapElementMapper } from './legsToSimpleSapElementMapper';
import { BackToSimpleSapElementMapper } from './backToSimpleSapElementMapper';
import { WallSupportToSimpleSapElementMapper } from './wallSupportToSimpleSapEleemntMapper';
import { HangerToSimpleSapElementMapper } from './hangerToSimpleSapElement';
import { LegsSupportToSimpleSapElementMapper } from './legsSupportToSimpleSapElementMapper';
import { IElementToSimpleSapElementMapperFactory } from '../IElementToSimpleSapElementMapperFactory';

export class ElementToSimpleSapElementMapperFactory
    implements IElementToSimpleSapElementMapperFactory {
    private body = new BodyToSimpleSapElementMapper();
    private front = new FrontToSimpleSapElementMapper();
    private drawer = new DrawerToSimpleSapElementMapper();
    private shelf = new ShelfToSimpleSapElementMapper();
    private verticalWall = new VerticalWallToSimpleSapElementMapper();
    private horizontalWall = new HorizontalWallToSimpleSapElementMapper();
    private handle = new HandleToSimpleSapElementMapper();
    private legs = new LegsToSimpleSapElementMapper();
    private back = new BackToSimpleSapElementMapper();
    private wallSupport = new WallSupportToSimpleSapElementMapper();
    private hanger = new HangerToSimpleSapElementMapper();
    private legsSupport = new LegsSupportToSimpleSapElementMapper();
    private null = new NullToSimpleSapELementMapper();

    public getMapperFor(element: Element): IElementToSimpleSamElementsMapper {
        const type = element.type;
        const specyficType = element.specyficType;
        if (type === ElementType.BODY) {
            return this.body;
        } else if (type === ElementType.FRONT) {
            return this.front;
        } else if (specyficType === SpecyficType.DRAWER) {
            return this.drawer;
        } else if (specyficType === SpecyficType.SHELF) {
            return this.shelf;
        } else if (specyficType === SpecyficType.VERTICAL_WALL) {
            return this.verticalWall;
        } else if (specyficType === SpecyficType.HORIZONTAL_WALL) {
            return this.horizontalWall;
        } else if (type === ElementType.LEGS) {
            if (element.shaderName !== 'ShaderNPodp') {
                return this.legs;
            } else {
                return this.legsSupport;
            }
        } else if (type === ElementType.HANDLE) {
            return this.handle;
        } else if (type === ElementType.BACK) {
            return this.back;
        } else if (type === ElementType.WALL_SUPPORT) {
            return this.wallSupport;
        } else if (specyficType === SpecyficType.HANGER) {
            return this.hanger;
        } else {
            return this.null;
        }
    }
}
